
import { computed, defineComponent, PropType, ref } from 'vue';

import EasyDrop from "@/components/EasyDrop.vue";

import { SearchBookingOverview, SearchHotelPension, SearchHotelRoom, SearchTravelBookingOverviewRooms } from '@/types/models';
import { useStore } from 'vuex';
import { LocaleStrings, ValueIndexParams } from '@/types/paramModels';

export default defineComponent({
  name: "PensionView",
  components: {
    EasyDrop
  },
  props: {
    bookingOverview: {
      type: Object as PropType<SearchBookingOverview>,
      required: true,
    },
    selectedRooms: {
      type: Array as PropType<Array<SearchHotelRoom>>,
      required: true
    },
    searchQuery: {
      type: Object,
      required: true
    },
    pageTexts: {
      type: Object,
      required: true
    },
    localeStrings: {
      type: Object as PropType<LocaleStrings>,
      required: true
    }
  },
  setup(_props) {
    const store = useStore();

    const showModal = ref(false);
    const selectedPension = ref<SearchHotelPension>();


    const openModal = (event: Event, pension: SearchHotelPension) => {
      event.preventDefault();
      selectedPension.value = pension;
      showModal.value = true;
    }

    const closeModal = () => {
      selectedPension.value = {} as SearchHotelPension;
      showModal.value = false;
    }

    const fixBody = () => {
      document.body.classList.add("modal-active");
    }

    const unfixBody = () => {
      document.body.classList.remove("modal-active");
    }

    const pensionIndex = computed(() => store.getters["ApplicationModule/getPensionIndex"]);

    const query = computed(() => _props.searchQuery);

    const searchBookingOverview = computed(() => _props.bookingOverview);

    const selectedRoom = (paxRoom: SearchTravelBookingOverviewRooms) => {
      return paxRoom.rooms.find(room => room.isSelected);
    }

    const updatePension = (event: Event, pension: SearchHotelPension, index: number) => {
      const input = event.target as HTMLInputElement;
      if (input.checked && !pension.isSelected) {
        const params = { value: pension, index: index } as ValueIndexParams;
        store.dispatch('TravelSearchBookingModule/updatePension', params);
      } else {
        input.checked = true;
      }
    }

    const changeIndex = (add: boolean) => {
      if (add && pensionIndex.value < searchBookingOverview.value.paxRooms.length - 1)
        store.dispatch('ApplicationModule/incrementPensionIndex')
      else if (!add && pensionIndex.value > 0)
        store.dispatch('ApplicationModule/decrementPensionIndex')

      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }

    const adultSinglePlural = (count: number) => {
      return count > 1 ? _props.pageTexts['searchbarPersonPickerLabelAdults'] : _props.pageTexts['searchbarPersonPickerLabelAdult'];
    }

    const childSinglePlural = (count: number) => {
      return count > 1 ? _props.pageTexts['searchbarPersonPickerLabelChildren'] : _props.pageTexts['searchbarPersonPickerLabelChild'];
    }

    return {
      query,
      pensionIndex,
      changeIndex,
      selectedRoom,
      searchBookingOverview,
      selectedPension,
      showModal,
      updatePension,
      openModal,
      closeModal,
      adultSinglePlural,
      childSinglePlural,
      fixBody,
      unfixBody
    }
  },
})
